export default function Logout (props) {

    return (
        <svg className={props.className} style={props.style} fill={props.fill || '#000'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 36">
            <path d="M 16 0 L 0 0 L 0 36 L 16 36 L 16 32 L 4 32 L 4 4 L 16 4 M 8 16 L 30 16 L 21 7 L 24 4 L 38 18 L 24 32 L 21 29 L 30 20 L 8 20"/>
        </svg>
    )

}